import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import { withRouter } from "../../providers/withRouter";
import { createComment, getComments, updateComment } from '../../services/comment.service';
import { IoSave } from "react-icons/io5";
import Delete from "../../icons/delete.svg";
import Editar from "../../icons/editar.svg";
import { UsuarioContext } from '../../providers/userContext';
import { editarComentario, eliminarComentario, fijarComentario, formatoFechasEs } from '../../functions/funciones';
import ModalEditarComentarios from "./../../components/proveedores/AllComments";
import { CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, RadioGroup, FormControlLabel, Radio, FormControl, FormLabel, FormGroup, Checkbox } from '@mui/material';
import { IoMail, IoCall, IoLogoWhatsapp } from "react-icons/io5";
import { BsPinAngle } from "react-icons/bs";
import { BsPin } from "react-icons/bs";
import ComentariosEstructura from '../comentariosEstructura';

const Comentarios = (props) => {
  const { t, i18n } = useTranslation('common');

  const user = useContext(UsuarioContext)
  const [comentario, setComentario] = useState('');
  const [recargar, setRecargar] = useState(0);
  const [comentarios, setComentarios] = useState([]);
  const [modalEditarOpened, setModalEditarOpened] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [fijado, setFijado] = useState(false);
  // Modal de tipo de contacto al guardar/editar como externo
  const [modalContactoOpen, setModalContactoOpen] = useState(false);
  const [tiposContacto, setTiposContacto] = useState([]); // varios motivos
  const [canalesContacto, setCanalesContacto] = useState([]); // ['mail','llamada','whatsapp']
  const [editandoExterno, setEditandoExterno] = useState(null); // comm siendo editado, o null si es alta

  const TIPOS_CONTACTO_EXTERNO_BASE = [
    { value: 'solicitud_docs', i18nKey: 'comments.contactTypes.solicitudDocs', spanish: 'Solicitud de documentación' },
    { value: 'llamada_fallida_correo', i18nKey: 'comments.contactTypes.llamadaFallidaCorreo', spanish: 'Llamada fallida y correo de seguimiento' },
    { value: 'explicacion_docs', i18nKey: 'comments.contactTypes.explicacionDocs', spanish: 'Explicación de la documentación requerida y cómo obtenerla' },
    { value: 'subida_actualizacion', i18nKey: 'comments.contactTypes.subidaActualizacion', spanish: 'Subida o actualización de documentación' },
    { value: 'incidencias_plataforma', i18nKey: 'comments.contactTypes.incidenciasPlataforma', spanish: 'Resolución de incidencias o dudas sobre la plataforma' },
    { value: 'verificacion_datos', i18nKey: 'comments.contactTypes.verificacionDatos', spanish: 'Verificación de los datos del proveedor' },
  ];
  const TIPOS_CONTACTO_EXTERNO = TIPOS_CONTACTO_EXTERNO_BASE.map(o => ({
    ...o,
    label: t(o.i18nKey, { defaultValue: o.spanish }),
  }));

  const supp = props.supp;
  const userIdFilter = props.userIdFilter;
  const fechaDesde = props.fechaDesde;
  useEffect(() => {
    const fetchComentarios = async () => {
      setIsLoading(false);
      try {
        const response = await getComments({
          filtros: {
            supp_id: supp.id,
            tipo: "comment",
            ...(userIdFilter !== undefined && { user_id: userIdFilter }),
            ...(fechaDesde && { fechaDesde }),
          }
        });
        const comentariosFiltrados = response.data.map(comment => {
          comment.usuario = comment.user?.consultant?.[0] || comment.user?.admin?.[0] || comment.user?.technician?.[0];
          return comment;
        });
        setComentarios(comentariosFiltrados);
      } catch (error) {
        console.error("Error fetching comments:", error);
      }
    };
    fetchComentarios();
  }, [supp.id, recargar, i18n.language, userIdFilter, fechaDesde]);



  function abrirModalExterno() {
    setEditandoExterno(null);
    setTiposContacto([]);
    setCanalesContacto([]);
    setModalContactoOpen(true);
  }

  function abrirModalEditarExterno(comm) {
    const lineas = String(comm?.texto || '')
      .split('\n')
      .map(l => l.replace(/^•\s*/, '').trim())
      .filter(Boolean);
    const tipos = [];
    for (const linea of lineas) {
      const match = TIPOS_CONTACTO_EXTERNO.find(o => o.label === linea || o.spanish === linea);
      if (match && !tipos.includes(match.value)) tipos.push(match.value);
    }
    const canales = String(comm?.tipo_contacto || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);
    setEditandoExterno(comm);
    setTiposContacto(tipos);
    setCanalesContacto(canales);
    setModalContactoOpen(true);
  }

  function cerrarModalExterno() {
    setModalContactoOpen(false);
    setEditandoExterno(null);
    setTiposContacto([]);
    setCanalesContacto([]);
  }

  const toggleCanalContacto = (val) => {
    setCanalesContacto((prev) =>
      prev.includes(val) ? prev.filter((x) => x !== val) : [...prev, val]
    );
  };

  const toggleTipoContacto = (val) => {
    setTiposContacto((prev) =>
      prev.includes(val) ? prev.filter((x) => x !== val) : [...prev, val]
    );
  };

  function guardarComentarioInterno() {
    if (!comentario.trim()) return;
    try {
      const infoComentario = {
        prop_id: null,
        supp_id: supp.id,
        aaff_id: null,
        texto: comentario,
        tipo: "comment",
        tipo_contacto: '',
        ambito: 'interno',
        status: 1,
      }
      createComment(infoComentario).then(res => {
        handleSubirDocsCallback(res)
        setComentario('')
      })
    } catch (error) {
      console.log(error)
    }
  }

  function guardarComentarioExterno() {
    if (!tiposContacto.length) return;
    const textoMotivo = TIPOS_CONTACTO_EXTERNO
      .filter((o) => tiposContacto.includes(o.value))
      .map((o) => `• ${o.label}`)
      .join('\n');
    const infoComentario = {
      prop_id: null,
      supp_id: supp.id,
      aaff_id: null,
      texto: textoMotivo,
      tipo: "comment",
      tipo_contacto: canalesContacto.join(','),
      ambito: 'externo',
      status: true,
    }
    const promesa = editandoExterno
      ? updateComment(editandoExterno.id, infoComentario)
      : createComment(infoComentario);
    promesa
      .then(res => {
        // Los servicios de comment tragan errores en el catch y devuelven undefined,
        // así que un res "vacío" o con status fuera de 2xx significa fallo real.
        if (!res || (res.status !== undefined && (res.status < 200 || res.status >= 300))) {
          throw new Error('UPDATE_FAILED');
        }
        handleSubirDocsCallback(res)
        cerrarModalExterno()
        toast.success(
          editandoExterno
            ? t('comments.updated', { defaultValue: 'Comentario actualizado' })
            : t('comments.externalSent', { defaultValue: 'Comentario externo enviado al AAFF' })
        )
      })
      .catch((err) => {
        console.log(err)
        toast.error(
          t('comments.externalError', { defaultValue: 'No se ha podido enviar el comentario externo' })
        )
      })
  }


  const handleSubirDocsCallback = () => {
    setRecargar(!recargar);
  };

  const editarComment = async (id, comm) => {
    if (comm?.ambito === 'externo') {
      abrirModalEditarExterno(comm);
      return;
    }
    editarComentario(id, user.id, comm).then((resultado) => {
      handleSubirDocsCallback(resultado)
    })
  }
  const eliminarComment = async (id) => {
    eliminarComentario(id).then((resultado) => {
      handleSubirDocsCallback(resultado)
    })
  }

  const fijarComment = async (id, fijado) => {
    fijarComentario(id, fijado).then((resultado) => {
      handleSubirDocsCallback(resultado)
    })
  };

  return (
    <>
      <ModalEditarComentarios
        comentarios={comentarios}
        opened={modalEditarOpened}
        eliminarComment={eliminarComment}
        editarComment={editarComment}
        fijarComment={fijarComment}
        handleClose={() => {
          setModalEditarOpened(false);
          // setRecargar(!recargar);
        }}
      />
      <Dialog open={modalContactoOpen} onClose={cerrarModalExterno} maxWidth="xs" fullWidth>
        <DialogTitle>
          {editandoExterno
            ? t('comments.editExternal', { defaultValue: 'Editar comentario externo' })
            : t('comments.contactType', { defaultValue: 'Tipo de contacto' })}
        </DialogTitle>
        <DialogContent>
          <FormControl component="fieldset" sx={{ mt: 1, width: '100%' }}>
            <FormLabel component="legend" sx={{ '&.Mui-focused': { color: '#92004D' } }}>
              {t('comments.reason', { defaultValue: 'Motivo' })}
            </FormLabel>
            <FormGroup>
              {TIPOS_CONTACTO_EXTERNO.map((opt) => (
                <FormControlLabel
                  key={opt.value}
                  control={
                    <Checkbox
                      checked={tiposContacto.includes(opt.value)}
                      onChange={() => toggleTipoContacto(opt.value)}
                      sx={{ '&.Mui-checked': { color: '#92004D' } }}
                    />
                  }
                  label={opt.label}
                />
              ))}
            </FormGroup>
          </FormControl>
          <FormControl component="fieldset" sx={{ mt: 2, width: '100%' }}>
            <FormLabel component="legend" sx={{ '&.Mui-focused': { color: '#92004D' } }}>
              {t('comments.channel', { defaultValue: 'Canal de contacto' })}
            </FormLabel>
            <FormGroup row>
              <FormControlLabel
                control={<Checkbox checked={canalesContacto.includes('mail')} onChange={() => toggleCanalContacto('mail')} sx={{ '&.Mui-checked': { color: '#92004D' } }} />}
                label={<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><IoMail /> {t('comments.contactMail', { defaultValue: 'Mail' })}</span>}
              />
              <FormControlLabel
                control={<Checkbox checked={canalesContacto.includes('llamada')} onChange={() => toggleCanalContacto('llamada')} sx={{ '&.Mui-checked': { color: '#92004D' } }} />}
                label={<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><IoCall /> {t('comments.contactCall', { defaultValue: 'Llamada' })}</span>}
              />
              <FormControlLabel
                control={<Checkbox checked={canalesContacto.includes('whatsapp')} onChange={() => toggleCanalContacto('whatsapp')} sx={{ '&.Mui-checked': { color: '#92004D' } }} />}
                label={<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><IoLogoWhatsapp /> {t('comments.contactWhatsapp', { defaultValue: 'Whatsapp' })}</span>}
              />
            </FormGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <button type="button" onClick={cerrarModalExterno} style={{ padding: '6px 14px', borderRadius: 5, border: '1px solid #ccc', background: '#fff', color: '#555' }}>
            {t('actions.cancel', { defaultValue: 'Cancelar' })}
          </button>
          <span style={!tiposContacto.length ? { opacity: 0.5, pointerEvents: 'none' } : undefined}>
            <button type="button" className="bigBtn" onClick={() => guardarComentarioExterno()}>
              <IoSave style={{ fontSize: 18 }} /><span style={{ marginLeft: 5 }} />
              {editandoExterno
                ? t('comments.edit', { defaultValue: 'Editar' })
                : t('comments.saveComments')}
            </button>
          </span>
        </DialogActions>
      </Dialog>
      {(() => {
        const comentariosInternos = (comentarios || []).filter(c => c.ambito !== 'externo');
        const comentariosExternos = (comentarios || []).filter(c => c.ambito === 'externo');
        const esAAFF = user.rol === "AAFF";

        const renderLista = (lista) => {
          if (!comentarios || isLoading) {
            return <CircularProgress style={{ height: 20, width: 20, color: '#92004D', position: 'absolute', top: '15%', left: '5%' }} />;
          }
          if (lista.length === 0) return t('comments.noComments');
          return lista.slice(0, 4).map(comm => (
            <ComentariosEstructura
              key={comm.id}
              comm={comm}
              eliminarComment={eliminarComment}
              editarComment={editarComment}
              fijarComment={fijarComment}
              readOnly={esAAFF}
            />
          ));
        };

        return (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: esAAFF ? '1fr' : '1fr 1fr',
              gap: 20,
              gridColumn: '1 / -1',
            }}
          >
            {!esAAFF && (
              <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 10, minHeight: 32 }}>
                  <b>{t('comments.internal', { defaultValue: 'Comentarios internos' })}</b>
                  {comentariosInternos.length > 4 && (
                    <button onClick={() => setModalEditarOpened(true)} style={{ borderRadius: 5, backgroundColor: '#92004D', color: '#ffffff', padding: '3px 10px', fontSize: 12 }}>{t('actions.showMore')}</button>
                  )}
                </div>
                <div style={{ overflow: 'auto', flex: 1, minHeight: 0, maxHeight: 200 }} className="comment-container">
                  {renderLista(comentariosInternos)}
                </div>
                <div className="comment-input-container" style={{ marginTop: 'auto', paddingTop: 10 }}>
                  <div className="comment-textarea-wrapper">
                    <textarea
                      id="comentarios"
                      name="comentarios"
                      value={comentario}
                      onChange={(e) => setComentario(e.target.value)}
                      rows={3}
                    />
                    <div className="comment-submit-container">
                      <button
                        type="button"
                        className="bigBtn"
                        onClick={guardarComentarioInterno}
                        style={{
                          opacity: comentario.trim() ? 1 : 0.5,
                          pointerEvents: comentario.trim() ? 'auto' : 'none',
                        }}
                      >
                        <IoSave style={{ fontSize: 20 }} /><span style={{ marginLeft: 5 }} />{t('comments.saveComments')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 10, minHeight: 32 }}>
                <b>{t('comments.external', { defaultValue: 'Comentarios externos' })}</b>
                {comentariosExternos.length > 4 && (
                  <button onClick={() => setModalEditarOpened(true)} style={{ borderRadius: 5, backgroundColor: '#92004D', color: '#ffffff', padding: '3px 10px', fontSize: 12 }}>{t('actions.showMore')}</button>
                )}
              </div>
              <div style={{ overflow: 'auto', flex: 1, minHeight: 0, maxHeight: 320 }} className="comment-container">
                {renderLista(comentariosExternos)}
              </div>
              {!esAAFF && (
                <div className="comment-input-container" style={{ marginTop: 'auto', paddingTop: 10 }}>
                  <div className="comment-submit-container">
                    <button
                      type="button"
                      className="bigBtn"
                      onClick={abrirModalExterno}
                    >
                      <IoSave style={{ fontSize: 20 }} /><span style={{ marginLeft: 5 }} />{t('comments.newExternal', { defaultValue: 'Nuevo comentario externo' })}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })()}
    </>
  );
}

export default withRouter(Comentarios);